import React, { FunctionComponent } from "react";
import { Toolbar, Typography } from "@material-ui/core";
import clsx from "clsx";
import DeleteTooltip from "components/DeleteTooltip/DeleteTooltip";
import useToolbarStyles from "../EnhancedTableHead/styles";
import { EnhancedTableToolbarProps } from "./types";

const EnhancedTableToolbar: FunctionComponent<EnhancedTableToolbarProps> = (
  props: EnhancedTableToolbarProps
) => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      {numSelected > 0 ? (
        <Typography
          className={classes.title}
          color="inherit"
          variant="subtitle1"
          component="div"
        >
          {numSelected} selected
        </Typography>
      ) : (
        <Typography
          className={classes.title}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          {props.title}
        </Typography>
      )}
      {numSelected > 0 && <DeleteTooltip handleDelete={props.onClick} />}
    </Toolbar>
  );
};

export default EnhancedTableToolbar;
